let idCounter = 0

export const generateId = () => {
  const id = idCounter
  idCounter += 1

  return id
}
